import { ContentState, EditorState, convertToRaw } from "draft-js";

export { loadTagOptions } from "./loadTagOptions";

export const truncate = (str) => {
  const length = 20;
  // shorter than length
  if (str.length <= length) {
    return str;
  }

  const newLength = length + `${str} `.slice(length - 1).search(" ");
  return `${str.slice(0, newLength - 1)}${
    str.slice(newLength).trim().length > 0 ? "..." : ""
  }`;
};

const short = require("short-uuid"); // https://www.npmjs.com/package/short-uuid

export function shortUUID() {
  return `${Math.floor(Date.now() / 1000)}-${short.generate()}`;
}

export function shortUuidRaw() {
  // date truncated to day, days since epoch
  return `${Math.floor(Date.now() / 86400000)}-${short.generate()}`;
}

export function makeid(length) {
  let result = "";
  const characters = "ABCDEFGHJKLMNPQRSTUVWXYZ";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

export function getImportedFileName(file) {
  const f = file.slice(file.indexOf("-") + 1);
  return f.slice(f.indexOf("-") + 1);
}

export function createEditorState(initialtext = "") {
  return convertToRaw(
    EditorState.createWithContent(
      ContentState.createFromText(initialtext)
    ).getCurrentContent()
  );
}
